<template>

  <v-row class="inner-content">
    <v-col>
      <AccountsTable />
    </v-col>
  </v-row>

</template>

<script>
export default {
  name: 'AccountsList',

  components: {
    AccountsTable: () => import('@/components/tables/AccountsTable.vue')
  },
}
</script>
